import { LoginCredentials, AuthResponse, User } from '../types';
import apiClient from './apiClient';

/**
 * Authentication API service - Connected to Flask backend
 */
export const authApi = {
  /**
   * Login user with credentials
   */
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    return apiClient.post<AuthResponse>('/auth/login', credentials, { skipAuth: true });
  },

  /**
   * Logout user
   */
  logout: async (): Promise<void> => {
    return apiClient.post('/auth/logout');
  },

  /**
   * Get current user profile
   */
  getCurrentUser: async (): Promise<{ user: User }> => {
    return apiClient.get<{ user: User }>('/auth/me');
  },

  /**
   * Refresh auth token
   */
  refreshToken: async (refreshToken: string): Promise<{ access_token: string }> => {
    return apiClient.post<{ access_token: string }>('/auth/refresh', undefined, {
      headers: {
        'Authorization': `Bearer ${refreshToken}`
      }
    });
  },

  /**
   * Change password
   */
  changePassword: async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
  },

  /**
   * Request password reset OTP
   */
  forgotPassword: async (email: string): Promise<{ message: string; success: boolean }> => {
    return apiClient.post<{ message: string; success: boolean }>('/auth/forgot-password', { email }, { skipAuth: true });
  },

  /**
   * Verify OTP and get reset token
   */
  verifyOtp: async (email: string, otp: string): Promise<{ message: string; reset_token: string; expires_in_minutes: number }> => {
    return apiClient.post<{ message: string; reset_token: string; expires_in_minutes: number }>('/auth/verify-otp', { email, otp }, { skipAuth: true });
  },

  /**
   * Reset password with reset token
   */
  resetPassword: async (resetToken: string, newPassword: string): Promise<{ message: string }> => {
    return apiClient.post<{ message: string }>('/auth/reset-password', {
      reset_token: resetToken,
      new_password: newPassword
    }, { skipAuth: true });
  },
};

export default authApi;
